module.exports = __webpack_public_path__ + "static/media/request-appointment-white.f39ff3ea.svg";